module.exports = __webpack_public_path__ + "static/img/img-bl.d9eb670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-bl.png
// module id = 1/od
// module chunks = 63